export enum PriceChoice {
    YIELD = "yield",
    PRICE = "price",
    PRICE_WITH_VAT = "priceWithVat"
}
